import { DateTime } from "luxon";

import ShortAgendaRow from "./ShortAgendaRow";
import { capitalizeWord } from "../../../_helpers/stringHelper";
import { IService } from "../../serviceOrdering/reducers";

export type ShortAgendaProps = {
  services: IService[];
};

const ShortAgenda = (props: ShortAgendaProps) => {
  const agendaStart = DateTime.now().startOf("day");
  const agendaEnd = DateTime.now().plus({ month: 1 });

  const getServicesByDate = (targetDateTime: DateTime) => {
    return Object.values(props.services).filter((service) => {
      if (service?.appointment?.startDate) {
        return DateTime.fromISO(service.appointment.startDate).hasSame(
          targetDateTime,
          "day",
        );
      }
      return null;
    });
  };

  const agendaServices = () => {
    const shortAgendaRender = [];
    let i = 1;
    for (
      let datePointer = agendaStart;
      datePointer <= agendaEnd;
      datePointer = datePointer.plus({ day: 1 })
    ) {
      const shortAgendaTitle = capitalizeWord(
        datePointer.setLocale("fr").toRelativeCalendar() || "",
      );
      const services = getServicesByDate(datePointer);

      const shortAgendaRows = services.map((service: IService) => (
        <ShortAgendaRow service={service} key={service.id} />
      ));

      if (services.length >= 1) {
        shortAgendaRender.push(
          <div
            key={datePointer.toISO()}
            className={`text-center short-agenda-date ${
              i === 1 ? "mt-2" : "mt-4"
            } mb-1`}
          >
            {shortAgendaTitle}
          </div>,
          ...shortAgendaRows,
        );
        i++;
      }
    }
    return shortAgendaRender;
  };

  return (
    <div className="overflow-auto" style={{ height: "350px" }}>
      {agendaServices()}
    </div>
  );
};

export default ShortAgenda;
